import { render } from "./StoreBaseMargin.vue?vue&type=template&id=45bbf86b&scoped=true"
import script from "./StoreBaseMargin.vue?vue&type=script&lang=js"
export * from "./StoreBaseMargin.vue?vue&type=script&lang=js"

import "./StoreBaseMargin.vue?vue&type=style&index=0&id=45bbf86b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bbf86b"]])

export default __exports__